export default function ViewSelector({ active, onChange }) {
  const options = [
    { key: "timeline", label: "Liste" },
    { key: "week", label: "Semaine" },
    { key: "month", label: "Mois" },
  ];

  return (
    <div className="segmented-control" data-active="1">
      {options.map((o) => (
        <button
          key={o.key}
          aria-selected={active === o.key}
          className={`segment-btn ${active === o.key ? "active" : ""}`}
          data-view={o.key}
          onClick={() => onChange(o.key)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
